import { Card } from "antd";
import { CardProps } from "antd/lib/card";

export const FormCard = (props: CardProps) => {
  return (
    <Card className="mb-2" {...props}>
      {props.children}
    </Card>
  );
};
